export function formatCurrency(amount: number, currency: string = 'MXN'): string {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(amount);
}

/** Muestra minutos totales como "45 min", "2 h" o "1 h 30 min". */
export function formatDevelopmentMinutes(total: number | null | undefined): string {
  if (total == null || total === 0) {
    return '—';
  }
  if (total < 60) {
    return `${total} min`;
  }
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (m === 0) {
    return `${h} h`;
  }
  return `${h} h ${m} min`;
}

/**
 * Convierte entrada de usuario a minutos enteros.
 * Cadena vacía → null (sin valor / borrar).
 */
export function parseDevelopmentTimeToMinutes(
  value: string,
  unit: 'minutes' | 'hours',
): number | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }
  const n = parseFloat(trimmed.replace(',', '.'));
  if (Number.isNaN(n) || n < 0) {
    return null;
  }
  if (unit === 'hours') {
    return Math.round(n * 60);
  }
  return Math.round(n);
}
